export const GET_PAYMENT_TYPES = 'GET_PAYMENT_TYPES'
export const GET_RECHARGE_PAYMENT_METHODS = 'GET_RECHARGE_PAYMENT_METHODS'
export const GET_CARD_TYPES = 'GET_CARD_TYPES'
export const GET_RECURRING_PAYMENT_SUBSCRIPTION =
  'GET_RECURRING_PAYMENT_SUBSCRIPTION'

export const GET_BUNDLE_GIFTING_PAYMENT_TYPES = 'GET_BUNDLE_GIFTING_PAYMENT_TYPES'
export const GET_PAY_OTHERS_BILLS_PAYMENT_TYPES = 'GET_PAY_OTHERS_BILLS_PAYMENT_TYPES'